<template>
  <div>
    <Notifications />
    <AnnouncementModal v-if="signedIn" :current-user-id="currentUser.id" />
    <component :is="layout">
      <router-view />
    </component>
  </div>
</template>

<script>
const defaultLayout = "public-layout";
import PublicLayout from "./layouts/PublicLayout.vue";
import PosLayout from "./layouts/PosLayout.vue";
import PlatformLayout from "./layouts/PlatformLayout.vue";
import AdminLayout from "./layouts/AdminLayout.vue";
import { Notifications } from "@estaly/ui";
import AnnouncementModal from "./components/announcement/AnnouncementModal.vue";
import { mapActions, mapState } from "vuex";

export default {
  components: {
    PublicLayout,
    PosLayout,
    PlatformLayout,
    AdminLayout,
    Notifications,
    AnnouncementModal,
  },
  mounted() {
    this.clearAllNotifications();
    const APP_ID = process.env.VUE_APP_INTERCOM_APP_ID;
    (function () {
      var w = window;
      var ic = w.Intercom;
      if (typeof ic === "function") {
        ic("reattach_activator");
        ic("update", w.intercomSettings);
      } else {
        var d = document;
        var i = function () {
          i.c(arguments);
        };
        i.q = [];
        i.c = function (args) {
          i.q.push(args);
        };
        w.Intercom = i;
        var l = function () {
          var s = d.createElement("script");
          s.type = "text/javascript";
          s.async = true;
          s.src = "https://widget.intercom.io/widget/" + APP_ID;
          var x = d.getElementsByTagName("script")[0];
          x.parentNode.insertBefore(s, x);
        };
        if (document.readyState === "complete") {
          l();
        } else if (w.attachEvent) {
          w.attachEvent("onload", l);
        } else {
          w.addEventListener("load", l, false);
        }
      }
    })();

    if (this.signedIn) this.connect();
  },

  computed: {
    ...mapState("auth", ["signedIn", "currentUser"]),

    layout() {
      return this.$route.meta.layout || defaultLayout;
    },
  },

  methods: {
    ...mapActions("notifications", ["clearAll"]),
    ...mapActions("cable", ["connect"]),

    clearAllNotifications() {
      this.clearAll();
    },
  },
};
</script>
